import {
  CsvExport,
  ExcelExport,
  ExcelSheet,
} from '../models/api/core/export/export';

export class ProviderExportMapper {
  static toCsvExport(rows: any[], fileName: string): CsvExport {
    const headers = [
      'Type',
      'Provider/Facility',
      'Address',
      'City',
      'State',
      'Zip Code',
    ];

    const dataRows = rows.map((row) => [
      row.type || '',
      row.providerFacility || '',
      row.address || '',
      row.city || '',
      row.state || '',
      row.zipCode || '',
    ]);

    return {
      fileName,
      headers,
      rows: dataRows,
    };
  }

  static toExcelExport(
    rows: any[],
    fileName: string,
    sheetLabel: string,
  ): ExcelExport {
    const headers = [
      'Type',
      'Provider/Facility',
      'Address',
      'City',
      'State',
      'Zip Code',
    ];

    const dataRows = rows.map((row) => [
      row.type || '',
      row.providerFacility || '',
      row.address || '',
      row.city || '',
      row.state || '',
      row.zipCode || '',
    ]);

    const sheet: ExcelSheet = {
      label: sheetLabel,
      headers,
      rows: dataRows,
    };

    return {
      fileName,
      sheets: [sheet],
    };
  }
}
